export default "<h4>\n  <span>{{computed}} {{message}}</span>\n</h4>\n"